import { render, staticRenderFns } from "./catalog_list_skeleton_loader.vue?vue&type=template&id=e2e29c0c"
import script from "./catalog_list_skeleton_loader.vue?vue&type=script&lang=js"
export * from "./catalog_list_skeleton_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports